import { takeEvery, takeLatest } from 'redux-saga/effects';
import { APPLICANT_MODULE } from '../../../configs/moduleNames';
import {
  EDIT_APPLICANT_BY_ID,
  LOAD_APPLICANT_BY_ID, LOAD_APPLICANT_LIST, LOAD_APPLICANT_LIST_ALL,
} from '../actions';
import loadApplicantById from './loadApplicantById';
import loadApplicantList from './loadApplicantList';
import { CREATE, DELETE_BY_ID } from '../../../configs/actionNames';
import deleteApplicant from './deleteApplicant';
import createApplicant from './createApplication';
import editApplicantById from './editApplicantById';
import loadApplicantListAll from './loadApplicantListAll';

export default function* watchClient() {
  yield takeLatest(APPLICANT_MODULE + LOAD_APPLICANT_LIST, loadApplicantList);
  yield takeEvery(APPLICANT_MODULE + LOAD_APPLICANT_LIST_ALL, loadApplicantListAll);
  yield takeLatest(APPLICANT_MODULE + CREATE, createApplicant);
  yield takeEvery(APPLICANT_MODULE + LOAD_APPLICANT_BY_ID, loadApplicantById);
  yield takeEvery(APPLICANT_MODULE + DELETE_BY_ID, deleteApplicant);
  yield takeEvery(APPLICANT_MODULE + EDIT_APPLICANT_BY_ID, editApplicantById);
}
